import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/taxonomy";
import { videos } from "@/mocks/videos";

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-6 md:py-14 lg:px-10">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">分类快捷入口</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按内容形态快速进入你感兴趣的频道</p>
        </div>
        <Link
          to="/category"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-400 transition-colors hover:text-primary-300 sm:flex"
        >
          全部内容
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {categoryEntries.map((entry) => {
          const count = videos.filter((v) => v.type === entry.type).length;
          return (
            <Link
              key={entry.key}
              to={`/category?type=${encodeURIComponent(entry.type)}`}
              className="group flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-500/60 md:p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <div className="w-full">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-400">
                    {entry.name}
                  </h3>
                  <span className="font-label text-xs text-foreground-500">{count} 部</span>
                </div>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{entry.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}